import React from "react";
import "./MianBuilder.css";
import MianBuilderLogo from "../../../assets/MB Logo 1.png";

function MianBuilder() {
  return (
    <div className="mian-builder-1-container">
      <div className="mian-builder-1-content">
        <div className="mian-builder-1-text-container">
          <h1 className="mian-builder-1-main-title">MianBuilder.com</h1>
          <h2 className="mian-builder-1-second-title">
            Crafting Dreams, Forging futures
          </h2>
          <p className="mian-builder-1-description">
            MianBuilder.com transcends being a mere construction platform; it
            crystallizes architectural aspirations into reality. Envision a
            space where blueprints seamlessly merge with the tangible world,
            where structures transcend mere physicality to embody living
            visions. Our platform isn't a conduit for construction alone; it
            evolves into a canvas where dreams find tangible expression. Whether
            crafting the foundations of new beginnings or sculpting towering
            achievements, each project isn't merely a structure; it resonates as
            a symphony of trust, a testament to our unwavering dedication to
            realizing aspirations.
            <br />
            <br />
            • Offering comprehensive construction solutions, spanning both
            residential and commercial projects.
            <br />
            • Encompassing infrastructure development, from roads to towering
            edifices and beyond.
            <br />• Architectural planning and meticulous execution tailored to
            a myriad of project types.
          </p>
        </div>
        <a
          href="http://mianbuilder.com" target="_blank" rel="noopener noreferrer"
          className="mian-builder-1-logo-link"
        >
          <div className="mian-builder-1-logo-container">
            <img
              src={MianBuilderLogo}
              alt="MianBuilderLogo"
              className="mian-builder-1-logo"
            />
          </div>
        </a>
      </div>
    </div>
  );
}

export default MianBuilder;
